import { Link } from "react-router-dom";
import Eyebrow from "@/components/base/Eyebrow";

interface CtaBandProps {
  title: string;
  description: string;
  to: string;
  buttonLabel: string;
}

export default function CtaBand({ title, description, to, buttonLabel }: CtaBandProps) {
  return (
    <section className="px-4 md:px-8 py-14 md:py-20">
      <div className="max-w-7xl mx-auto relative overflow-hidden border-2 border-foreground-950 bg-primary-500 px-6 md:px-12 py-10 md:py-16">
        <div className="absolute inset-0 grid-pattern opacity-40 pointer-events-none" aria-hidden="true"></div>
        <span className="absolute -right-8 -top-10 font-heading font-black uppercase leading-none text-[10rem] md:text-[16rem] text-foreground-950/10 select-none" aria-hidden="true">
          FX
        </span>
        <div className="relative flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div className="max-w-2xl">
            <Eyebrow tone="solid">Next step</Eyebrow>
            <h2 className="mt-4 font-heading font-black uppercase leading-[0.9] tracking-tight text-foreground-950 text-3xl md:text-5xl">
              {title}
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-800">
              {description}
            </p>
          </div>
          <Link
            to={to}
            className="inline-flex items-center justify-center gap-2 px-7 py-4 border-2 border-foreground-950 bg-foreground-950 text-primary-500 font-label text-xs uppercase tracking-[0.16em] font-semibold whitespace-nowrap hover:bg-background-50 hover:text-foreground-950 transition-colors cursor-pointer shrink-0"
          >
            {buttonLabel}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}